import Vue from 'vue';
import apiClient from '../../apiClient';

const state = {
  balance: 0,
  currency: 'руб.',
  tariff: null,
  userBilling: {},
  plan: {
    name: 'Базовый',
    expiresByDate: '28.07.2018',
    nextPaymentDate: '28.07.2018',
    nextCharge: 500
  },
  isFullFeatured: false,
  payments: [
    {
      paymentId: 'a180605/4099199',
      date: '01.10.2018',
      period: 'с 01.10.2018 по 28.10.2018',
      outgo: 20.4,
      status: 'списано',
      statusType: 'success',
      details: 'Списание за дисковое пространство сверх тарифа'
    },
    {
      paymentId: 'a180605/4099199',
      date: '01.10.2018',
      period: 'с 01.10.2018 по 28.10.2018',
      income: 200,
      status: 'отказ',
      statusType: 'error',
      details: 'Отказ по неизвестной причине'
    }
  ]
};

const actions = {
  getUserBalance: ({ commit }, firmId) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/firms/${firmId}/billings`)
        .then(resp => {
          commit('setUserBalance', resp.data.balance);
          commit('setUserTariff', resp.data.tariff);
          commit('setUserBillings', resp.data);
          if (resp.data.tariff.isFullFeatured) {
            commit('setUserFullFeaturedState', resp.data.tariff.isFullFeatured);
          } else {
            commit('setUserFullFeaturedState', false);
          }
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    })
};

const mutations = {
  setUserBalance: (state, balance) => {
    Vue.set(state, 'balance', balance);
  },

  setUserTariff: (state, packageRaw) => {
    Vue.set(state, 'tariff', packageRaw);
  },

  setUserBillings: (state, billings) => {
    Vue.set(state, 'userBilling', billings);
  },

  setUserFullFeaturedState: (state, flag) => {
    Vue.set(state, 'isFullFeatured', flag);
  }
};

export default {
  state,
  actions,
  mutations
};
